$(function () {
  const attributionsBlock = $('#attributions-block');
  const affiliationsButton = $('#affiliations-button');

  affiliationsButton.click(() => {
    attributionsBlock.removeClass('v2-hidden');
    attributionsBlock.addClass('v2-flex');
  });

  affiliationsButton.on('click', function () {
    $('html, body').animate(
      { scrollTop: $(attributionsBlock).offset().top },
      500
    );
  });

  $(window).on('scroll', function () {
    if ($(window).scrollTop() === 0) {
      attributionsBlock.removeClass('v2-flex');
      attributionsBlock.addClass('v2-hidden');
    }
  });
});
